var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0772 10.2449V5.82208C16.0772 5.3984 15.7337 5.05493 15.31 5.05493V5.05493M0.925537 10.2449L0.925537 5.8237C0.925537 5.39912 1.26973 5.05493 1.6943 5.05493V5.05493",
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27832 6.99214H14.7216C15.4686 6.99214 16.0741 7.59771 16.0741 8.34472V13.4617C16.0741 14.2087 15.4686 14.8142 14.7216 14.8142H2.27832C1.53131 14.8142 0.925738 14.2087 0.925738 13.4617V8.34472C0.925738 7.59771 1.53131 6.99214 2.27832 6.99214Z",
    stroke: "currentColor",
    strokeWidth: 0.744542
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0714 11.342L12.552 11.342C12.2091 11.342 11.9311 11.064 11.9311 10.7211L11.9311 9.99391C11.9311 9.65097 12.2091 9.37297 12.552 9.37297L16.0714 9.37297L16.0714 11.342Z",
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.63482 2.68549C2.80674 1.91119 3.57384 1.4227 4.34819 1.59443L13.803 3.69125C14.5773 3.86298 15.0657 4.62989 14.8937 5.40419L14.7168 6.20085C14.6585 6.1948 14.5993 6.1917 14.5394 6.1917H6.31351L2.79771 5.41199L2.62458 6.1917H2.28237C2.13066 6.1917 1.98359 6.21157 1.84363 6.24885L2.63482 2.68549ZM14.1615 5.24181L14.0522 5.73405L3.25774 3.34011L3.36703 2.84787C3.44917 2.47794 3.81567 2.24456 4.18562 2.3266L13.6404 4.42342C14.0103 4.50547 14.2437 4.87187 14.1615 5.24181Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52314 2.68627L12.5201 1.79282C12.9427 1.71726 13.3475 1.99586 13.4278 2.41759L13.7708 4.21817",
    stroke: "currentColor",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletOutline);
export default __webpack_public_path__ + "static/media/wallet-outline.c6659ef0b5d014dfc465fb2d80e7d912.svg";
export { ForwardRef as ReactComponent };